import { PureComponent } from 'react'
import { Field as FinalFormField, FieldRenderProps } from 'react-final-form'

import { isDeepEqual } from '@/server-data'

import { NumericInputField } from './NumericInputField'
import { PublicProps as Props } from './typings'

export default class NumericInputFieldWrapper extends PureComponent<Props> {
  render() {
    const { name, ...props } = this.props

    return (
      <FinalFormField
        {...props}
        name={name}
        isEqual={isDeepEqual}
        render={(formProps: FieldRenderProps<any>) => {
          return <NumericInputField {...this.props} formProps={formProps} />
        }}
      />
    )
  }
}
